import type { AppRoute } from "@/lib/types";

export function getSearchHomePath() {
  return "/search";
}

export function getSearchPath(searchId: string) {
  return `/search/${encodeURIComponent(searchId)}`;
}

export function parseAppRoute(pathname: string): AppRoute {
  if (pathname === "/" || pathname === "/search") {
    return { kind: "home" };
  }

  const parts = pathname.split("/").filter(Boolean);
  if (parts.length === 2 && parts[0] === "search" && parts[1]) {
    return { kind: "search", searchId: decodeURIComponent(parts[1]) };
  }

  return { kind: "not-found", path: pathname };
}
